import React from 'react';

const SvgDk = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="DK_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="DK_svg__b" fill="#fff">
        <use xlinkHref="#DK_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M8 0v8H0V1.99C0 .892.9 0 1.991 0H8zm4 0h14.009C27.109 0 28 .898 28 1.99V8H12V0zm16 12v6.01c0 1.099-.9 1.99-1.991 1.99H12v-8h16zM8 20H1.991C.891 20 0 19.102 0 18.01V12h8v8z"
        fill="#EF264D"
        mask="url(#DK_svg__b)"
      />
    </g>
  </svg>
);

export default SvgDk;
